// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sNjEsJAv4v5EsaYAT0Sw{margin-bottom:16px}.z3_7VHUcsUdFSANuChVN{gap:8px;margin-bottom:16px}.qfwjPG7bNtEFn0xoMDOa{align-items:center;gap:16px;margin-bottom:24px;padding-right:4px;display:flex}.hwYaLhofEgypDbVrEfbx{height:334px;margin-bottom:32px;margin-right:-22px}.UlD_Ecj1dsFfNWuxEb_p [aria-label=Scrollbar_View]{padding-right:20px}.yUqYz_8DYBU1vOOgrv2J{margin-top:8px}.Kt7xUfWBl7gdXutvKV9V{gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": `sNjEsJAv4v5EsaYAT0Sw`,
	"name": `z3_7VHUcsUdFSANuChVN`,
	"section": `qfwjPG7bNtEFn0xoMDOa`,
	"table": `hwYaLhofEgypDbVrEfbx`,
	"table__scroll": `UlD_Ecj1dsFfNWuxEb_p`,
	"tableScroll": `UlD_Ecj1dsFfNWuxEb_p`,
	"tableSpinner": `yUqYz_8DYBU1vOOgrv2J`,
	"wrapBtn": `Kt7xUfWBl7gdXutvKV9V`
};
export default ___CSS_LOADER_EXPORT___;
